
const prefix = 'task';
export const EVENTS_TASK = {
  ADDED: `${prefix}.added`,
  EDITED: `${prefix}.edited`,
  DELETED: `${prefix}.deleted`,  
}; 
